<template>
    <md-modal-dialog v-slot="{ title, message, confirmText, cancelText, confirmDisabled = false, cancelDisabled = false}"
    :md-close-on-esc="false"
    :md-click-outside-to-close="false">
      <md-dialog-content>
        <md-dialog-title>{{ title }}</md-dialog-title>
        <div class="message">
          <p class="message-height font-bold">{{message}}</p>
          <p class="message-height"> Please make sure the applicants details are correct.</p>
          <p class="message-height voi-fields">
            VOI fields are:
            <ul class="message-ul">
              <li>First Name</li>
              <li>Last Name</li>
              <li>Gender</li>
              <li>Current Address</li>
            </ul>
          </p>
        </div>

        <div class="action-buttons-cover">
          <md-dialog-actions>
            <md-button class="md-primary md-flat" @click="onCancel" :disabled="cancelDisabled" v-if="cancelText">{{cancelText}}</md-button>
            <md-button class="md-primary md-flat" @click="onConfirm" :disabled="confirmDisabled" v-if="confirmText">{{confirmText}}</md-button>
          </md-dialog-actions>
        </div>
      </md-dialog-content>
    </md-modal-dialog>
</template>
<script>

export default {
  methods: {
    onCancel(){
      this.$modal.submit(false);
    },
    onConfirm(){
      this.$modal.submit(true);
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

  .submit-btn {
    background-color: $ausloans-green-dark !important;
  }

  .md-dialog-content {
    margin: 2px;
  }

  .md-dialog-content > * {
    margin-left: 20px;
  }

  .md-progress-spinner {
    padding: 17px;
    margin-left: 5vw;
  }
  .action-buttons {
    bottom: 52px;
    margin-left: 10%;
    margin-bottom: -50px;
  }

  .message-ul{
    padding-left: 40px;
    line-height: 2;
  }

  .md-dialog-title {
    margin: 0;
    padding-left: 20px;
  }

  .message {
    padding-top: 12px
  }

  .voi-fields {
    padding-top: 10px
  }

</style>
